export default __webpack_public_path__ + "static/media/img4.6bf26f11.png";